import { Button } from "@/components/elements/Button";
import { useAdminUserList } from "@/api/services/admin/user";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import { CountTable } from "@/components/elements/CountTable";
import { IconPlus } from "@/assets/icons";

type TAdminUserListTopProps = {};

export const AdminUserListTop: FC<TAdminUserListTopProps> = () => {
  const { data } = useAdminUserList();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <CountTable total={data?.pagination.total} page={data?.pagination.page} perPage={data?.pagination.perPage} />
      <Button component={Link} size="sm" variant="primary" to={AppRoutes.adminUserCreate} startIcon={<IconPlus />}>
        irohana担当者追加
      </Button>
    </Stack>
  );
};
